import { render } from "./OInputText.vue?vue&type=template&id=651f0c96&scoped=true"
import script from "./OInputText.vue?vue&type=script&lang=js"
export * from "./OInputText.vue?vue&type=script&lang=js"

import "./OInputText.vue?vue&type=style&index=0&id=651f0c96&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651f0c96"]])

export default __exports__